import React, { Component } from 'react';

import TextField from '../../global/fields/TextField';
import { Select } from 'antd';
import AddIcon from '../../Icons/AddIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GroupPlaceholder from '../../../assets/images/group_placeholder.svg';
import Button from '../../global/Button';
import { connect } from 'react-redux';
import ImageApi from '../../../api/image';
import { TranslateApi } from '../../../api';

class CreateFeedItemCommunity extends Component {
  constructor(props) {
    super(props);

    this.fileInputRef = React.createRef();

    this.state = {
      title: {
        value: '',
        error: null,
      },
      location: {
        value: '',
        error: null,
      },
      description: {
        value: '',
        error: null,
      },
      details: {
        value: '',
        error: null,
      },
      phone: {
        value: '',
        error: '',
      },
      email_address: {
        value: '',
        error: '',
      },
      imageFile: null,
      imageBlobUrl: '',
      isEndTimeAdded: false,
      selectActive: false,
      language: '',
      supportedLanguages: [],
      translationError: ''
    };
  }

  async componentDidMount() {
    const result = await TranslateApi.getSupportedLanguages()
    if (result && result.success) {
      this.setState({
        supportedLanguages: result.data
      })
    }

    if (!this.props.currentCommunity) return null;

    const { title, location, description, details, phone, email_address, image, image_id } =
      this.props.currentCommunity;

    this.setState({
      title: {
        value: title,
        error: null,
      },
      location: {
        value: location,
        error: null,
      },
      description: {
        value: description,
        error: null,
      },
      details: {
        value: details,
        error: null,
      },
      phone: {
        value: phone || '',
        error: '',
      },
      email_address: {
        value: email_address || '',
        error: '',
      },
    });

    if (image) {
      ImageApi.getImage(image.url).then((img) => {
        this.setState({
          imageBlobUrl: img,
          image_id: image_id,
        });
      });
    }
  }

  _onManageAttachmentClick = () => {
    this.fileInputRef.current.click();
  };

  _onFileSelect = (event) => {
    this.setState({
      imageFile: event.target.files[0],
      imageBlobUrl: URL.createObjectURL(event.target.files[0]),
    });
  };

  _submit = () => {
    if (typeof this.props.onSubmit !== 'function') return;

    const { title, description, location, details, phone, email_address, imageFile, image_id } =
      this.state;

    const data = {
      title,
      description,
      location,
      details,
      phone,
      email_address,
      image_id,
    };

    if (imageFile) data.image = imageFile;

    this.props.onSubmit('Community', data);
  };

  _shouldShowButton = () => {
    if (typeof this.props.checkFields !== 'function') return;

    const { title, description, location, email_address, details, phone, imageFile } = this.state;

    const data = {
      title,
      description,
      location,
      phone,
      email_address,
      details,
      image: null,
    };

    if (imageFile) data.image = imageFile;

    return this.props.checkFields('Community', data);
  };

  _onSupportedLanguageChange = newValue => {
    this.setState({ language: newValue });
    this.select.blur();
  };

    renderOptions (data) {
      const options = [];
  
      for (let i = 0; i < data.length; i++) {
        options.push(
          <Select.Option key={`lengthDur:${data[i].value}`} value={data[i].value}>
            <div className='create-feed-select-dropdown-option'>
              {data[i].label}
            </div>
          </Select.Option>,
        );
      }
  
      return options;
    }

  _translate = async() => {
    const {title, details, location, description, language} = this.state
    let translatedTitle, translatedDescription, translatedLocation, translatedDetails;

    const resultTitle = await TranslateApi.getTranslation(language, title.value)
    if (resultTitle && resultTitle.success) {
      translatedTitle = resultTitle.data
    }

    const resultDetails = await TranslateApi.getTranslation(language, details.value)
    if (resultDetails && resultDetails.success) {
      translatedDetails = resultDetails.data
    }

    const resultLocation = await TranslateApi.getTranslation(language, location.value)
    if (resultLocation && resultLocation.success) {
      translatedLocation = resultLocation.data
    }

    const resultDescription = await TranslateApi.getTranslation(language, description.value)
    if (resultDescription && resultDescription.success) {
      translatedDescription = resultDescription.data
    }

    if (!translatedDescription || !translatedLocation || !translatedDetails || !translatedTitle) {
        this.props.addAlertToAlerts({
          title: 'Message',
          message: 'Translation to your selected language is not currently available.',
          confirmBtnText: 'Okay',
        });
    } else {
      this.setState({
        title: {value: translatedTitle},
        description: {value: translatedDescription},
        location: {value: translatedLocation},
        details: {value: translatedDetails}
      })
    }
  }

  render() {
    const showButton = this._shouldShowButton();

    return (
      <div className="create-feed-extra-block create-feed-event-content">
        <div className="create-feed-event-image-holder">
          {this.state.imageBlobUrl ? (
            <img
              src={this.state.imageBlobUrl}
              className="create-feed-event-image"
              alt="attachment"
            />
          ) : (
            <img
              src={GroupPlaceholder}
              className="create-feed-event-image-placeholder"
              alt="placeholder"
              width="88"
            />
          )}

          <input
            type="file"
            style={{ display: 'none' }}
            ref={this.fileInputRef}
            onChange={this._onFileSelect}
          />
        </div>

        <div
          className="create-feed-add-text align-self-center"
          onClick={this._onManageAttachmentClick}
        >
          <AddIcon className="create-feed-add-icon" />
          {this.state.imageBlobUrl ? 'REPLACE IMAGE' : 'ADD AN IMAGE'}
        </div>

        <TextField
          fk="title"
          value={this.state.title.value}
          updateFieldData={(fk, value, error) => this.setState({ title: { value, error } })}
          label="Community title"
          validateObj={{ requiredMax128: this.state.title.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <TextField
          fk="description"
          value={this.state.description.value}
          updateFieldData={(fk, value, error) => this.setState({ description: { value, error } })}
          fieldTag="textarea"
          rows="3"
          label="Description"
          validateObj={{ requiredMax2048: this.state.description.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <TextField
          fk="location"
          value={this.state.location.value}
          updateFieldData={(fk, value, error) => this.setState({ location: { value, error } })}
          label="Location"
          validateObj={{ requiredMax128: this.state.location.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <TextField
          fk="phone"
          type="text"
          validateRule="tel"
          value={this.state.phone.value}
          updateFieldData={(fk, value, error) => this.setState({ phone: { value, error } })}
          label="Phone"
          validateObj={{ tel: this.state.phone.value }}
          showError={true}
          triggerOnChange
        />

        <TextField
          fk="email_addrees"
          value={this.state.email_address.value}
          updateFieldData={(fk, value, error) => this.setState({ email_address: { value, error } })}
          label="Email address"
          validateObj={{ emailOptional: this.state.email_address.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

        <TextField
          fk="details"
          value={this.state.details.value}
          updateFieldData={(fk, value, error) => this.setState({ details: { value, error } })}
          fieldTag="textarea"
          rows="3"
          label="Details"
          validateObj={{ requiredMax2048: this.state.details.value }}
          showError={this.props.showErrors}
          triggerOnChange
        />

         {this.state.supportedLanguages.length ? (
            <>
              <div className='create-feed-translation-holder'>
                <span
                  className={`create-feed-select-label ${
                    this.state.selectActive || this.state.language ? 'active' : ''
                  }`}
                  onClick={() => this.select.focus()}
                >
                  Supported languages
                </span>
  
                <Select
                  ref={ref => (this.select = ref)}
                  value={this.state.language}
                  onChange={this._onSupportedLanguageChange}
                  className='create-feed-select'
                  showArrow={false}
                  dropdownClassName='create-feed-select-dropdown'
                  defaultActiveFirstOption={false}
                  open={this.state.selectActive}
                  onFocus={() => this.setState({ selectActive: true })}
                  onBlur={() => this.setState({ selectActive: false })}
                >
                  {this.renderOptions(this.state.supportedLanguages)}
                </Select>
  
                <FontAwesomeIcon className='create-feed-select-icon' icon={['fas', 'chevron-down']} />
              </div>
              {this.state.translationError ? (
                <div className="field-container__error-wrapper">
                  <p className="field-container__error m-0">Unable to translate the post</p>
                </div>
              ) : (null)}
              <div className="create-feed-post-button">
                <Button.Primary onClick={this._translate} disabled={!showButton || !this.state.language}>
                  Translate
                </Button.Primary>
              </div>
            </>
          ) : (null)}

        <div className="create-feed-post-button">
          <Button.Primary onClick={this._submit} type="submit" disabled={!showButton}>
            {this.props.communityId ? "SAVE" : "CREATE"}
          </Button.Primary>
        </div>
        <div className="create-feed-empty-space" />
      </div>
    );
  }
}

export default connect((state) => ({
  currentCommunity: state.communities.currentCommunity,
}))(CreateFeedItemCommunity);
